<template>
  <component
    :is="component"
    :value="model"
    v-bind="$attrs"
    v-on="$listeners"
    @input="updateModel"
    @keyup.space="checkForSpaces"
    @change="updateModel"
  >
    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </component>
</template>

<script>
import { VTextField, VSlider, VTextarea } from 'vuetify/lib';

export default {
  name: 'StInputComponent',
  components: {
    VTextField, VSlider, VTextarea
  },
  inheritAttrs: false,
  props: {
    component: {
      type: String,
      required: true
    },
    trim: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    initialValue: {}
  },
  data() {
    return {
      model: this.initialValue
    };
  },
  methods: {
    checkForSpaces(event) {
      const { value } = event.target;
      if (this.trim && !value.trim()) {
        event.target.value = value.trim();
      }
      return event;
    },
    updateModel(value) {
      this.model = value;
      this.$emit('input', this.model);
      return this.model;
    },
    getValue() {
      return this.model;
    }
  }
};
</script>
